module.exports = __webpack_public_path__ + "assets/1-new-york-sales-recruiting-agency.46e1d2f8.png";